// eslint-disable-next-line import/prefer-default-export
export const collaboratorsOptionMapper = (collaborators) =>
  collaborators.map((user) => ({
    label: user.display_name,
    value: user.local_id,
  }));
